module.exports = __webpack_public_path__ + "img/cancel.784bdab2.svg";